export const faqCollapse = () => {
    const collapseButtons = document.querySelectorAll('.faq-title');

    collapseButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const faqRow = button.closest('.faq-row');
            const collapseText = faqRow.querySelector('.info');

            const isOpen = !collapseText.classList.contains('collapsed');

            document.querySelectorAll('.info').forEach((text) => text.classList.add('collapsed'));

            if (!isOpen) {
                collapseText.classList.remove('collapsed');
                document.querySelectorAll('.button-faq.collapsed').forEach((button) => {
                    button.classList.remove('collapsed')
                });
            }

            button.querySelector('.button-faq').classList.toggle('collapsed');
        });
    });
};
